<app-toolbar id="kt_app_toolbar" class="app-toolbar py-lg-6"></app-toolbar>

<div class="card rounded-2">
	<div class="card-body bg-gray-200 p-4">
		<ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
			<!-- <li class="nav-item">
				<a class="nav-link" data-bs-toggle="tab" href="#client_manager_pane_1">Add New Client</a>
			</li> -->
			<!-- <li class="nav-item">
				<a class="nav-link" data-bs-toggle="tab" href="#client_manager_pane_2">Client List</a>
			</li> -->
			<!-- <li class="nav-item">
				<a class="nav-link active" data-bs-toggle="tab" href="#client_manager_pane_3">Export</a>
			</li> -->
		</ul>
		<div class="tab-content" id="myTabContent">
			<div class="tab-pane fade" id="client_manager_pane_1" role="tabpanel">
				<div class="d-flex justify-content-center align-items-center" style="min-height: 200px;">
					<button type="button" class="btn btn-primary btn-lg" (click)="openAddClientModal()">
						<i class="ki-duotone ki-plus fs-2">
							<span class="path1"></span>
							<span class="path2"></span>
							<span class="path3"></span>
						</i>
						Add New Client
					</button>
				</div>
			</div>
			<div class="tab-pane show active" id="client_manager_pane_2" role="tabpanel">
				<app-client-manage-list (clientUpdated)="onClientUpdated()"></app-client-manage-list>
			</div>
			<div class="tab-pane fade  " id="client_manager_pane_3" role="tabpanel">
				<app-client-export-list></app-client-export-list>
			</div>
		</div>
	</div>
</div>

<app-export-modal></app-export-modal>
<app-edit-client-modal #editClientModal (clientUpdated)="onClientUpdated()"></app-edit-client-modal>